import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
  from,
  gql,
  split,
} from "@apollo/client"
import { getToken, getImpersonationHeader } from "../lib/auth"
import {
  educationPersonaLink,
  getEducationPersonaTypePolicies,
} from "../components/EducationPersonaSwitcher/personaLink"
import { resolvers, defaults } from "./Resolvers"

export const COACH_TOOLS_API = "coachTools"
const cache = new InMemoryCache({
  possibleTypes: {
    MembershipEducationSeminarRegistration: [
      "MembershipEducationSeminarRegistrationRegistered",
      "MembershipEducationSeminarRegistrationCompleted",
      "MembershipEducationSeminarRegistrationNotRegistered",
    ],
  },
  typePolicies: getEducationPersonaTypePolicies(),
})

const DEFAULT_QUERY = gql`
  {
    isDirty @client {
      component
      __typename
    }
    isLoading @client {
      component
      __typename
    }
    isEditing @client {
      component
      __typename
    }
    savedSuccess {
      isSaved
      __typename
    }
  }
`
cache.writeQuery({
  query: DEFAULT_QUERY,
  data: defaults,
})

const typeDefs = `
  type AuthCustomFields
  type AuthProfile {
    customFields: AuthCustomFields
  }
`

export const graphqlUri = baseEndpoint => operation => {
  const endpoint = `${baseEndpoint}/graphql`
  return operation.operationName
    ? `${endpoint}?op=${operation.operationName}`
    : endpoint
}

export const splitLink = split(
  operation => {
    const { api } = operation.getContext()
    return api === COACH_TOOLS_API
  },
  new HttpLink({
    uri: graphqlUri(process.env.REACT_APP_COACH_TOOLS_GRAPHQL_ENDPOINT),
  }),
  new HttpLink({
    uri: graphqlUri(process.env.REACT_APP_GRAPHQL_ENDPOINT),
  }),
)

export const addAuthToken = token =>
  token ? { Authorization: `Bearer ${token}` } : {}

export const authContext =
  tokenLoader =>
  async (operation, { headers }) => {
    let token
    try {
      token = await tokenLoader()
    } catch (e) {
      window.location.replace("/login")
      return { headers }
    }

    return {
      headers: {
        ...headers,
        ...addAuthToken(token),
        ...getImpersonationHeader(),
        "X-Client-Name": "account-pga-org",
      },
    }
  }

const authLink = new ApolloLink(async (operation, forward) => {
  const headers = operation.getContext().headers || {}
  const authHeader = await authContext(getToken)(operation, { headers })
  operation.setContext({ headers: authHeader.headers })
  return forward(operation)
})

const apolloClient = new ApolloClient({
  link: from([authLink, educationPersonaLink, splitLink]),
  cache,
  typeDefs,
  resolvers,
  connectToDevTools: process.env.NODE_ENV !== "production",
})

export default apolloClient
